import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { CreditCard, Users } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';
import { BreadcrumbItem } from '@/components/Breadcrumb';
import { Helmet } from 'react-helmet-async';
import { t } from 'i18next';

const settingsTabs = [
  { path: 'billing', label: t('payment.bill', 'Billing'), icon: CreditCard },
  { path: 'referrals', label: t('payment.referrals', 'Referrals'), icon: Users },
];

const SettingsLayout: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const getPageTitle = () => {
    if (location.pathname.includes('referrals')) return t('payment.referrals', 'Referrals');
    if (location.pathname.includes('billing')) return t('payment.bill', 'Billing');
    return t('payment.title');
  };

  const breadcrumbs: BreadcrumbItem[] = [
    { label: t('payment.referrals', 'referrals'), path: '/home' },
    { label: t('payment.bill', 'bill'), path: '/settings/billing' },
    { label: getPageTitle() },
  ];

  return (
    <div className="space-y-6">
      <Helmet>
        <title>{getPageTitle()} - BeQs Hodings Reward</title>
      </Helmet>
      <PageHeader title={t('payment.title')} breadcrumbs={breadcrumbs} />

      <div className="!border-b !border-gray-200 dark:!border-dark-border">
        <nav className="flex gap-6">
          {settingsTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <NavLink
                key={tab.path}
                to={tab.path}
                end={tab.path === ''}
                className={({ isActive }) =>
                  `flex items-center gap-2 pb-3 !text-sm !font-medium !border-b-2 !transition-colors !no-underline ${
                    isActive
                      ? '!border-primary !text-primary dark:!border-primary-light dark:!text-primary-light'
                      : '!border-transparent !text-gray-500 dark:!text-gray-400 hover:!text-gray-700 dark:hover:!text-gray-300'
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                {t(tab.label)}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <Outlet />
    </div>
  );
};

export default SettingsLayout;
